import React, { useState } from "react";
import {
  CancelButton,
  ProceedButton,
  BackArrowButton,
  CloseButton,
} from "../../../fixedassetelements/button/Button";
import UploadIcon from "../../../assets/icons/UploadButton.png";
import success from "../../../assets/icons/Group.png";
import { uploadPayableFile } from "../../../../Bookclosure/Services/ApiHandler";
import styles from "./UploadPayableFile.module.css";
import commonstyles from "../Forms.module.css";

function UploadFile({ PayableID, onClose , onProceedToPayableUploadedFiles, onBack, onChangeFile }) {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    const newFiles= Array.from(e.target.files);
    setUploadedFiles((prev) => [...prev,...newFiles]);
    setError("");
  };

  const handleClose = () => {
    setUploadedFiles([]);
   if(onClose) onClose();
  };

  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    if (files.length === 0) return;

    setUploadedFiles((prev) => [...prev, ...files]);
    setError("");
  };

  const handleProceed = async () => {
  if(uploadedFiles.length === 0) return;

    try {
      const formData = new FormData();
      uploadedFiles.forEach((file)=> formData.append("file",file));
    
      const res = await uploadPayableFile(PayableID, formData);
      console.log("Uploaded:", res.data);

      if(onProceedToPayableUploadedFiles){
        onProceedToPayableUploadedFiles(uploadedFiles);
        setUploadedFiles([]);
      }
    }catch(err){
      console.error(err);
      setError("Upload failed");
    }
  };

  return (
        <div className={commonstyles.backdrop}>
          <div
            className={`${commonstyles.container} ${commonstyles.smallContainer}`}
          >
            <div className={commonstyles.header}>
              <div className={commonstyles.headerLeft}>
                <BackArrowButton onClick={onBack} />
                <h2 className={commonstyles.heading}>
                  Upload Payable Register(Multiple Excel Files)
                </h2>
              </div>
              <CloseButton onClick={handleClose} />
            </div>

            <div className={styles.center}>
              <div className={styles.rightUploadTxt}>
                <h6 className={styles.textUpload}>Upload as sheets</h6>
                <span className={styles.changetxt} onClick={onChangeFile}>Change</span>
              </div>
              <div
                className={`${styles.uploadBox} ${isDragging ? styles.dragActive : ""}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <p className={styles.dragText}>
                  Drag and drop your file here or
                </p>

                <label htmlFor="fileInput" className={styles.uploadBtn}>
                  <span className={styles.uploadImgText}>
                    <img
                      src={UploadIcon}
                      alt="Upload"
                      className={styles.uploadImg}
                    />
                    <h6 className={styles.uploadText}>Upload</h6>
                  </span>
                </label>

                <input
                  type="file"
                  id="fileInput"
                  className={styles.hiddenInput}
                  accept=".csv,.xlsx,.xls"
                  onChange={handleFileChange}
                  multiple
                />
              </div>

               {uploadedFiles.length > 0 ? (
                  <p className={styles.fileName}>
                    <img src={success} alt="success" className={styles.successTick} />
                    {uploadedFiles.length} {uploadedFiles.length === 1 ? "file" : "files"} uploaded
                  </p>
                ) : (
                  <p className={styles.note}>
                    File you upload must contain all the mandatory fields for mapping.
                  </p>
                )}

              {error && <p className={styles.errorText}>{error}</p>}
           </div>

            <div className={commonstyles.footer}>
              <CancelButton onClick={handleClose} />
              <ProceedButton
                onClick={handleProceed}
                disabled={uploadedFiles.length === 0}
              />
            </div>
          </div>
        </div>
  );
}

export default UploadFile;
